import sortBy from 'lodash/sortBy';

import {
  getVehicleMakesSorterFunction
} from '../../../utilities/getVehicleMakesSorterFunction';
import { getPopularMakesList } from '../../../utilities/getPopularMakesList';

export const actions = {
  async getNadaMakes ({ commit, rootGetters }) {
    commit('SET_MODELS', []);

    const getVehicleMakes = rootGetters['vehicle/getVehicleMakesFunction'];
    const vehicleMakes = await getVehicleMakes(rootGetters['vehicle/year']);

    const vehicleMakesSorter = getVehicleMakesSorterFunction(
      getPopularMakesList(rootGetters['vehicle/makeName'])
    );

    commit('SET_MAKES', sortBy(vehicleMakes, [vehicleMakesSorter]));
  },
  async getNadaModels ({ commit, rootGetters }) {
    commit('SET_MODELS_REQUEST_FINISHED', false);
    commit('SET_MODEL_IMAGES_REQUEST_FINISHED', false);

    const getVehicleModels = rootGetters['vehicle/getVehicleModelsFunction'];

    let vehicleModels = [];

    try {
      vehicleModels = await getVehicleModels(
        rootGetters['vehicle/year'],
        rootGetters['vehicle/makeId'],
        rootGetters['vehicle/modelName']
      );
    } finally {
      commit('SET_MODELS_REQUEST_FINISHED', true);
    }

    commit('SET_MODELS', vehicleModels);

    try {
      const getVehicleModelsWithImage = rootGetters['vehicle/getVehicleModelsWithImageFunction'];

      const vehicleModelsWithImage = await getVehicleModelsWithImage(
        rootGetters['vehicle/year'],
        rootGetters['vehicle/makeName'],
        vehicleModels
      );

      commit('SET_MODELS', vehicleModelsWithImage);
    } finally {
      commit('SET_MODEL_IMAGES_REQUEST_FINISHED', true);
    }
  },
  async getNadaTrims ({ commit, rootGetters }) {
    const getVehicleTrims = rootGetters['vehicle/getVehicleTrimsFunction'];

    const vehicleTrims = await getVehicleTrims(
      rootGetters['vehicle/year'],
      rootGetters['vehicle/makeId'],
      rootGetters['vehicle/modelId']
    );

    commit('SET_TRIMS', vehicleTrims);
  },
  getNadaYears ({ commit, rootGetters }) {
    if (rootGetters['vehicle/hasLoadedYears']) {
      return;
    }

    const currentDate = new Date();

    let maximumYear = currentDate.getFullYear() + 1;
    const minimumYear = maximumYear - Number(process.env.MINIMUM_VEHICLE_YEARS);

    const years = [];

    for (; maximumYear >= minimumYear; maximumYear--) {
      years.push({ id: maximumYear, name: maximumYear });
    }

    commit('SET_YEARS', years);
  },
  setMake ({ commit }, make) {
    commit('SET_MAKE', make);
  },
  setPayoffAmount ({ commit }, payoffAmount) {
    commit('SET_PAYOFF_AMOUNT', payoffAmount);

    // we need this set on the global store so we can
    // calculate the monthly payment using offer data
    commit('global/SET_AMOUNT_FINANCED', payoffAmount, { root: true });
  },
  setPayoffAmountConfirmed ({ commit }, payoffAmountConfirmed) {
    commit('SET_PAYOFF_AMOUNT_CONFIRMED', payoffAmountConfirmed);
  },
  setPayoffAmountConfirmedValue ({ commit }, payoffAmountConfirmedValue) {
    commit('SET_PAYOFF_AMOUNT_CONFIRMED_VALUE', payoffAmountConfirmedValue);
  },
  setMileage ({ commit }, mileage) {
    commit('SET_MILEAGE', mileage);
  },
  setModel ({ commit }, model) {
    commit('SET_MODEL', model);
  },
  setTrim ({ commit }, trim) {
    commit('SET_TRIM', trim);
  },
  setYear ({ commit }, year) {
    commit('SET_YEAR', year);
  }
};
